import React from 'react'

import MenuItems from './MenuItems'
import Open from './Open'
import Sidebar from './Sidebar'

class App extends React.Component {

  public render() {
    return (
      <React.Fragment>
        <Sidebar
          drawerHeader={<Open />}
          menuItems={<MenuItems />}
        />
      </React.Fragment>
    )
  }
}

export default App



// WEBPACK FOOTER //
// ./src/App.tsx